import environments from 'environments';
import Honeybadger from 'honeybadger-js';

Honeybadger.configure({
  apiKey: environments.honeyBadgerApiKey,
  revision: process.env.REACT_APP_GIT_SHA,
  environment: process.env.NODE_ENV,
  disabled: process.env.NODE_ENV !== 'production',
});

// eslint-disable-next-line import/prefer-default-export
export const notifyError = (component, context = {}) => (
  message,
  errorContext
) => {
  if (process.env.NODE_ENV === 'production') {
    Honeybadger.notify(message, component, {
      context: {
        ...context,
        errorContext,
      },
    });
  } else {
    // eslint-disable-next-line no-console
    console.error(component, message, context);
  }
};
